import { render } from "./ButtonLocation.vue?vue&type=template&id=f0449b86&scoped=true"
import script from "./ButtonLocation.vue?vue&type=script&lang=js"
export * from "./ButtonLocation.vue?vue&type=script&lang=js"

import "./ButtonLocation.vue?vue&type=style&index=0&id=f0449b86&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0449b86"]])

export default __exports__